import { render } from "./TvmFlowEndGeneralComponents.vue?vue&type=template&id=31c95c68"
import script from "./TvmFlowEndGeneralComponents.vue?vue&type=script&lang=js"
export * from "./TvmFlowEndGeneralComponents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ChatWidget/TvmFlowEndItems/TvmFlowEndGeneralComponents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31c95c68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31c95c68', __exports__)) {
    api.reload('31c95c68', __exports__)
  }
  
  module.hot.accept("./TvmFlowEndGeneralComponents.vue?vue&type=template&id=31c95c68", () => {
    api.rerender('31c95c68', render)
  })

}


export default __exports__